import * as FileSaver from 'file-saver';
import i18n from 'i18next';
import * as XLSX from 'xlsx';
import {
    generateCustomReport_OpraQueries_generateCustomReport_CustomReport_tabs_CustomReportResultsTab as Tabs,
    generateCustomReport_OpraQueries_generateCustomReport_CustomReport_tabs_CustomReportResultsTab_data_CustomReportResultsRowType as TabData,
    generateCustomReport,
} from '@queries/generated/reports.generated';

// needs moving to type declaration file
type AnyJson = boolean | number | string | null | JsonArray | JsonMap;
interface JsonMap {
    [key: string]: AnyJson;
}
interface JsonArray extends Array<AnyJson> {}

const customReportGenerator = (customReport: generateCustomReport, reportName: string) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    let _workbookSheetData: JsonArray = [];

    const getReportTabs = (customReport: generateCustomReport) =>
        customReport.generateCustomReport?.tabs?.map((tab) => ({
            ...tab,
            tabType: i18n.t(`reports:${tab?.tabType}`),
            columns: tab?.columns?.map((column) => i18n.t(`reports:${column}`)),
        }));

    const getTabNames = (customReport: generateCustomReport) =>
        customReport.generateCustomReport.tabs.map((tab: any) => i18n.t(`reports:${tab?.tabType}`));

    const getFormattedReportData = (tab: Tabs) => {
        const reportTabData = [];
        let rowData = {};
        const tabColumnHeaders: string[] = tab.columns;
        const tabData: TabData[] = tab.data;

        if (tabData.length > 0) {
            for (let i = 0; i <= tabData.length - 1; i++) {
                for (let x = 0; x <= tabColumnHeaders.length - 1; x++) {
                    rowData = {
                        ...(rowData as object),
                        ...{
                            [tabColumnHeaders[x]]: tabData[i].row[x],
                        },
                    };
                }
                reportTabData.push(rowData);
            }
        } else {
            for (let x = 0; x <= tabColumnHeaders.length - 1; x++) {
                rowData = {
                    ...(rowData as object),
                    ...{
                        [tabColumnHeaders[x]]: '',
                    },
                };
                reportTabData.push(rowData);
            }
        }

        return reportTabData;
    };

    const generateWorkSheetData = (tab: Tabs) => {
        const reportData = getFormattedReportData(tab);

        const worksheet = XLSX.utils.json_to_sheet(reportData);

        const sheetsData = {
            [tab.tabType]: worksheet,
        };

        _workbookSheetData = { ..._workbookSheetData, ...sheetsData };
    };

    const generateWorkbookData = () => {
        const customReportTabs = getReportTabs(customReport);

        customReportTabs.map((tab: Tabs) => {
            generateWorkSheetData(tab);
        });
    };

    const exportToExcel = (customReport: generateCustomReport, reportName: string) => {
        const reportSheetNames: string[] = getTabNames(customReport);

        generateWorkbookData();

        const workbook = { Sheets: _workbookSheetData, SheetNames: reportSheetNames };

        writeFile(workbook, reportName);
    };

    const writeFile = (workbook: any, fileName: string) => {
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    exportToExcel(customReport, reportName);
};

export default customReportGenerator;
